import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const usePreferredStore = (storeName)=>{
    const { getFormattedLabel , getLabel  } = useIntl();
    const [preferredStoreState, setPreferredStoreState] = React.useState(null);
    const { preferredStoreSuccess , preferredStoreUpdated , preferredStoreLabel  } = preferredStoreState !== null && preferredStoreState !== void 0 ? preferredStoreState : {};
    const preferredStoreAlertLabel = preferredStoreSuccess ? getFormattedLabel(preferredStoreLabel !== null && preferredStoreLabel !== void 0 ? preferredStoreLabel : '', {
        labelData: {
            storeName
        },
        parseLink: true
    }) : getLabel(preferredStoreLabel !== null && preferredStoreLabel !== void 0 ? preferredStoreLabel : '');
    const onHandlePreferredStoreChange = (updated, success, label)=>{
        setPreferredStoreState({
            preferredStoreUpdated: updated,
            preferredStoreSuccess: success,
            preferredStoreLabel: label
        });
    };
    return {
        preferredStoreAlertLabel,
        preferredStoreUpdated,
        preferredStoreSuccess,
        onHandlePreferredStoreChange
    };
};
var usePreferredStore$1 = usePreferredStore;

export { usePreferredStore$1 as default };
//# sourceMappingURL=use-preferred-store.js.map
